import React, { ChangeEvent, useState } from 'react';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  InputLabel,
  TextField
} from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoadingButton from '@mui/lab/LoadingButton';
import CustomAlert, { CustomAlertType } from '../../../Components/CustomAlert';
import ClawbackRequest from '../../../Model/clawbackRequest';
import { clawback } from '../../../api/support';
import { useTranslation } from 'react-i18next';

const Clawback = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorType, setErrorType] = useState<CustomAlertType>();
  const [account, setAccount] = useState<string>();
  const [nftId, setNftId] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();

  const { t } = useTranslation();

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.id;
    const { value } = e.target;

    switch (field) {
      case 'account': {
        setAccount(value);
        break;
      }
      case 'nftId': {
        setNftId(value);
        break;
      }
      default:
        break;
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity()) {
      const submitData: ClawbackRequest = {
        account: account!
      };
      setLoading(true);
      try {
        const result = await clawback(nftId, submitData);
        setLoading(false);
        if (result.data.success) {
          setLoading(false);
          setShowError(true);
          setErrorMessage(`Sensore aggiunto, id: ${result.data.data.id}`);
          setErrorType(CustomAlertType.INFO);
          form.reset();
        } 
      } catch (reason: any) {
        setLoading(false);
        setShowError(true);
        setErrorMessage(reason.response.data.errorMessage);
        setErrorType(CustomAlertType.ALERT);
      }
    }
  };

  return (
    <Container>
      <Card sx={{ maxWidth: 600, padding: 0 }} style={{ margin: 'auto' }}>
        <CardHeader
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.125)' }}
          subheader="Move nft to creator account"
        ></CardHeader>
        <Box
          sx={{
            width: 'auto',
            maxWidth: '100%'
          }}
        >
          <form onSubmit={handleSubmit}>
            <CardContent>
              <InputLabel>{t('NFT_ID')}</InputLabel>
              <TextField
                required
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                fullWidth
                id="nftId"
                value={nftId}
                onChange={onChangeValue}
              />
              <Box sx={{ height: 20 }} />
              <InputLabel>{t('ACCOUNT')}</InputLabel>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                required
                fullWidth
                size="small"
                id="account"
                value={account}
                onChange={onChangeValue}
              />
            </CardContent>
            <CardActions>
              <LoadingButton
                loading={loading}
                variant="contained"
                style={{
                  marginLeft: 'auto',
                  marginRight: 10,
                  marginBottom: 10
                }}
                type="submit"
              >
                {t('MOVE')}
              </LoadingButton>
            </CardActions>
          </form>
        </Box>
      </Card>
      <CustomAlert
        show={showError}
        message={errorMessage}
        type={errorType}
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
      />
    </Container>
  );
};

export default Clawback;
